<template>
  <v-container class="py-12 mt-12 chapter-extra" fluid >
    <v-row class="py-12 my-12" id="chapter-extra">
      <v-col cols="12" md="10" offset-md="1" class="px-6 py-md-12 px-md-12 my-md-12">
        <h1 class="pb-12 border-bottom-grey" v-translate>Appendix</h1>

        <v-row justify="end" class="my-6 my-md-12">
          <v-col cols="12" md="8">
            <p class="subtitle">{{$root.siteSettings.extraDescription}}</p>
          </v-col>
        </v-row>

        <v-container class="card-container my-12 py-12">
          <transition name="fade" appear>
            <div class="arrow arrow-left" @click="onClickLeft">
              <ArrowIcon />
            </div>
          </transition>
          <transition name="fade" appear>
            <div class="arrow arrow-right" @click="onClickRight">
              <ArrowIcon />
            </div>
          </transition>

          <transition-group name="slide-away">
            <v-card
              class="mx-auto px-4 pt-1 pt-md-4"
              max-width="500"
              v-for="(extra, index) in currentExtras"
              :key="extra.image.id"
              :elevation="index"
              :style="{ 'transform': (index === currentExtras.length - 1) ? 'none': extra.rotation }"
              tile
            >
              <a :href="extra.link" target="_blank">
                <v-img
                  :height="($vuetify.breakpoint.mdAndUp) ? 300 : 150"
                  :src="'/media/' + extra.image.id"
                />
                <v-card-text>
                  <span class="float-right">{{extra.linkSource}}</span>
                  <h3 class="extra-title mt-8 mb-0 pb-0 col-md-10">{{extra.title}}</h3>
                  <p class="caption col-md-10 mt-2 pt-0 mb-0">{{extra.caption}}</p>
                </v-card-text>
              </a>
            </v-card>
          </transition-group>
        </v-container>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Viewport } from '@monogrid/vue-lib'
import random from 'lodash/random'
import ArrowIcon from '@/assets/svg/arrow.svg'
import map from 'lodash/map'
import Vue from 'vue'

export default {
  name: 'ChapterExtra',

  mixins: [Viewport],

  components: {
    ArrowIcon
  },

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      currentIndex: this.data.length - 1
    }
  },

  mounted () {
    map(this.data, (item) => {
      Vue.set(item, 'rotation', 'rotate(' + random(-25, 25) + 'deg)')
    })
  },

  methods: {
    onClickLeft () {
      this.currentIndex = this.currentIndex + 1 >= this.data.length ? 0 : this.currentIndex + 1
    },

    onClickRight () {
      this.currentIndex = this.currentIndex - 1 < 0 ? this.data.length - 1 : this.currentIndex - 1
    }
  },

  computed: {
    currentExtras () {
      return this.data.slice(0, this.data.length - this.currentIndex)
    }
  }
}
</script>

<style scoped lang="scss">

.chapter-extra {
  pointer-events: all;
}

.card-container {
  height: 500px;
  position: relative;
  margin-top: 80px !important;

  .v-card {
    position: absolute;

    top: 0;

    left: 0;
    right: 0;

    margin: auto;

    transition: transform 0.8s $ease-in-out-quart, opacity 0.4s ease-out;
  }
}

h3 {
  font-family: Barlow, sans-serif;
  font-weight: 600;
  font-size: 13px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: $c-gradient-bg;

  @include breakpoint('md-and-up') {
    font-size: 24px;
  }
}

p.caption {
  font-family: Lora;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #7777;

  @include breakpoint('md-and-up') {
    font-size: 15px;
  }
}

.arrow {
  position: absolute;

  top: -90px;
  margin: auto;
  pointer-events: all;
  cursor: pointer;

  @include breakpoint('md-and-up') {
    top: 50%;
    transform: translateY(-50%);
  }

  svg {
    width: 40px;
    height: 40px;
  }

  &-left {
    left: 10%;

    svg {
      transform: rotate(-180deg);
    }
  }

  &-right {
    right: 10%;
  }
}

.slide-away-enter-active {
  transition: transform 0.8s $ease-in-out-quart, opacity 0.2s ease-out 0.2s !important;
  pointer-events: none;
}

.slide-away-leave-active {
  transition: transform 0.8s $ease-in-out-quart, opacity 0.2s ease-out 0.4s !important;
  pointer-events: none;
}

.slide-away-enter,
.slide-away-leave-to {
  opacity: 0;
  transform: translateY(-300px) !important;
}
</style>
